// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__rHYwd","header":"PrivacyPolicy_header__CBn7q","body":"PrivacyPolicy_body__iT8HJ"};